/*var Promise = require('es6-promise').Promise;
require('es6-promise').polyfill();
import 'babel-polyfill'*/
import Vue from "vue";
import App from "./App.vue";
//import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { apolloProvider } from "./graphql";
//@ts-ignore
import vueSmoothScroll from "vue2-smooth-scroll";
Vue.use(vueSmoothScroll);
Vue.config.productionTip = false;

import { mix } from "./mixins/core";
import VueCookies from "vue-cookies";
import Meta from "vue-meta";

import { LocalizationPlugin } from "@/plugins/localization";
import { AxiosPlugin } from "@/plugins/axios";

Vue.mixin(mix);
Vue.use(VueCookies);
Vue.use(LocalizationPlugin);
Vue.use(AxiosPlugin);
Vue.use(Meta);

import Select from "@/components/Select.vue";
import Tag from "@/components/Tag.vue";
import Datepicker from "@/components/Datepicker.vue";
import Checkbox from "@/components/Checkbox.vue";
import ToggleButton from "@/components/ToggleButton.vue";
Vue.component("Select", Select);
Vue.component("Tag", Tag);
Vue.component("Checkbox", Checkbox);
//@ts-ignore
Vue.component("Datepicker", Datepicker);
Vue.component("ToggleButton", ToggleButton);

const vue = new Vue({
  router: router,
  store: store,
  render: (h) => h(App),
}).$mount("#app");
//@ts-ignore
store.$vm = vue;
